export enum InfoType {
  Room = "room",
  Date = "date",
  DepartureAirport = "departure_airport",
  FlightTimes = "flight_times",
}

export enum DayFillEnum {
  NONE = "none",
  MONTH = "month",
  WEEK = "week",
}

export enum DayFormatEnum {
  SHORT = "short",
  MEDIUM = "medium",
  LONG = "long",
}
